import { render, staticRenderFns } from "./SplitPanelB.vue?vue&type=template&id=69eee6cc&scoped=true"
import script from "./SplitPanelB.vue?vue&type=script&lang=js"
export * from "./SplitPanelB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69eee6cc",
  null
  
)

export default component.exports